<template>
    <div class="BaseModal__mask">
        <div :class="['BaseModal',className]">

            <!--HEADER-->
            <div class="BaseModal__header">

                <!--CLOSE-->
                <BaseNavigationButton :class-name="'BaseModal__header-close'"
                                      :icon="'icon-left'"
                                      @click="close($event.target)" />

                <!--TITLE-->
                <div class="BaseModal__header-title">
                    {{translate(title)}}
                </div>

                <!--SAVE-->
                <BaseButton :label="'COMMON__SAVE'"
                            :class-name="'BaseModal__header-save'"
                            :accent="true"
                            @click="save($event.target)" />
            </div>

            <!--BODY-->
            <div class="BaseModal__body">
                <slot></slot>
            </div>

            <!--BOTTOM-->
            <div class="BaseModal__bottom">

                <!--CLOSE-->
                <BaseButtonFlat :label="'COMMON__CLOSE'"
                                :class-name="'BaseModal__close'"
                                @click="close($event.target)" />

                <!--SAVE-->
                <BaseButton :label="'COMMON__SAVE'"
                            :class-name="'BaseModal__save'"
                            :accent="true"
                            @click="save($event.target)" />

            </div>
        </div>
    </div>
</template>

<script>
    import BaseButton from './BaseButton.vue';
    import BaseButtonFlat from './BaseButtonFlat.vue';
    import BaseNavigationButton from './BaseNavigationButton.vue';

    export default {
        name: 'BaseModal',
        components: {
            BaseButton,
            BaseButtonFlat,
            BaseNavigationButton
        },
        props: {
            //Title of the page
            title: {
                type: String
            },
            //Additional css class name for styling
            className: {
                type: String
            }
        },
        methods: {
            close: function (e) {
                this.$emit('close', e);
            },
            save: function (e) {
                this.$emit('save', e);
            }
        }
    };
</script>

<style>
    .BaseModal__mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: flex-start;
        padding-top: 30px;
        overflow: auto;
        background-color: rgba(0, 0, 0, .5);
    }

    @media (max-width: 600px) {
        .BaseModal__mask {
            padding: 0;
        }
    }

    .BaseModal {
        position: relative;
        background-color: #fff;
        width: 600px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    }

    .BaseModal__header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        background-color: #546E7A;
        padding: 8px;
        box-shadow: 0 2px 6px 0 rgba(0,0,0,.14);
        color: #fff;
        margin: 0;
        line-height: 2rem
    }

    .BaseModal__header-close {
        display: none;
        margin-right: 16px;
    }

    .BaseModal__header-save {
        display: none;
        min-width: 0;
        padding: 0 12px;
    }

    .BaseModal__header-title {
        text-align: center;
        flex: 1 1 auto;
        font-size: 1.25rem;
        -webkit-font-smoothing: antialiased;
        font-weight: 500;
        letter-spacing: .02em;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    @media (max-width: 600px) {
        .BaseModal__header-title {
            text-align: left;
        }

        .BaseModal__header-close {
            display: block;
        }

        .BaseModal__header-save {
            display: block;
        }
    }

    .BaseModal__body {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        padding: 10px;
    }

    .BaseModal__bottom {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: space-between;
        padding: 0 10px 10px 10px;
    }

    .BaseModal__close {
        display: block;
        flex: 0 0 auto;
        margin-right: 8px;
    }

    .BaseModal__save {
        display: block;
        flex: 0 0 auto;
    }

    @media (max-width: 600px) {
        .BaseModal {
            width: 100%;
            min-height: 100%;
        }

        .BaseModal__save {
            display: none;
        }

        .BaseModal__close {
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// BaseModal.vue?296fa1b2